import { atom, useAtom, WritableAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { useMemo } from 'react';

export const useCustomFieldHints = (
  cutomFieldId: number,
  customFieldsHintsAtom: WritableAtom<any, [any], void>,
) => {
  const customFieldFilterAtom = useMemo(
    () =>
      atom(
        (get) => get(focusAtom(customFieldsHintsAtom, (optic) => optic.prop(cutomFieldId))),
        (_get, set, cutomFieldValueId: string) => {
          set(customFieldsHintsAtom, { [cutomFieldId]: cutomFieldValueId });
        },
      ),
    [cutomFieldId],
  );

  return useAtom(customFieldFilterAtom);
};
